// hover на главной при наведени

import gsap from 'gsap';
import {auto} from "@popperjs/core";
import {isDesktop} from "../../functions/check-viewport";

function LinkHover() {
  if (isDesktop()) {
    const itemsContainer = document.querySelector('.sectionFour__items');
    const items = itemsContainer.querySelectorAll('.sectionFour__item');

    for (let i = 0; i < items.length; i++) {

      items[i].addEventListener("mouseover", (e) => {
        const img = items[i].querySelector('.sectionFour__item--img')
        const text = items[i].querySelector('.sectionFour__item--text')
        const arrow = items[i].querySelector('.arrow--size--l')
        const tl = gsap.timeline();
        tl.to(items[i], 0.1, {background: 'var(--primary4)'}, 0)
        tl.to(arrow, 0.1, {rotate: 45, color: 'var(--primary2)'}, 0)
        tl.to(text, 0.1, {color: 'var(--primary2)'}, 0)
        tl.to(img, 0.6,{width: auto, scale: 1})


      });

      items[i].addEventListener("mouseout", (e) => {
        const img = items[i].querySelector('.sectionFour__item--img')
        const text = items[i].querySelector('.sectionFour__item--text')
        const arrow = items[i].querySelector('.arrow--size--l')
        const tl = gsap.timeline();
        tl.to(items[i], 0.2, {background: 'var(--primary2)'}, 0)
        tl.to(arrow, 0.2, {rotate: 0, color: 'var(--primary1)'}, 0)
        tl.to(text, 0.2, {color: 'var(--primary1)'}, 0)
        tl.to(img, 0.6, {width: 0, scale: 0})



      });
    }
  }






}

export default LinkHover
